/**
 * Espionage / counter-espionage UI art on Vercel Blob (`land/espionage/*`).
 * Spread `ESPIONAGE_PRELOAD_URLS` into `VERCEL_BLOB_PRELOAD_PRIORITIZED` in `vercelBlobPreloadUrls.ts`.
 */

const D = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/espionage'
const D_V2 = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/espionage/espionage'
const REDESIGN_BLOB = 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Redesign'
const REDESIGN_ESPIONAGE_MISSION_MODAL = `${REDESIGN_BLOB}/espionage_mission_modal`
const REDESIGN_ESPIONAGE_TARGET_CHARACTER_MODAL = `${REDESIGN_BLOB}/espionage_target_character_modal`

/** Castle information modal parchment (`Redesign/espionage_castle_info/`). */
export const ESPIONAGE_CASTLE_INFO_BACKGROUND = `${REDESIGN_BLOB}/espionage_castle_info/background.webp`

/** Target character picker parchment (`Redesign/espionage_target_character_modal/`). */
export const ESPIONAGE_TARGET_CHARACTER_MODAL_BACKGROUND = `${REDESIGN_ESPIONAGE_TARGET_CHARACTER_MODAL}/background.webp`
export const ESPIONAGE_TARGET_CHARACTER_MODAL_CHARACTER_CARD = `${REDESIGN_ESPIONAGE_TARGET_CHARACTER_MODAL}/character_card.webp`
export const ESPIONAGE_TARGET_CHARACTER_MODAL_BTN_CLOSE = `${REDESIGN_ESPIONAGE_TARGET_CHARACTER_MODAL}/btn_close.webp`
export const ESPIONAGE_TARGET_CHARACTER_MODAL_BTN_START = `${REDESIGN_ESPIONAGE_TARGET_CHARACTER_MODAL}/btn_start.webp`

/** @deprecated Use ESPIONAGE_TARGET_CHARACTER_MODAL_BACKGROUND */
export const ESPIONAGE_SELECT_CHARACTER_BACKGROUND = ESPIONAGE_TARGET_CHARACTER_MODAL_BACKGROUND

export const ESPIONAGE_CONTAINER_HEAD_BG = `${D}/container_head.webp`
export const ESPIONAGE_CONTAINER_BODY_BG = `${D}/container_body.webp`
export const ESPIONAGE_CONTAINER_BACKGROUND = `${D}/container_background.webp`

export const ESPIONAGE_MISSION_ICON_SEARCH = `${D}/search.webp`
export const ESPIONAGE_MISSION_ICON_STEAL = `${D}/steal.webp`
export const ESPIONAGE_MISSION_ICON_LOYAL = `${D}/loyal.webp`
export const ESPIONAGE_MISSION_ICON_KILL = `${D}/kill.webp`

export const ESPIONAGE_STAR_FILLED = `${D}/star_filled.webp`
export const ESPIONAGE_STAR_UNFILLED = `${D}/star_unfilled.webp`

export const ESPIONAGE_REPORTS_HEADER_BG = `${D}/header.webp`
export const ESPIONAGE_REPORTS_PANEL_BG = `${D}/panel_bg.webp`
export const ESPIONAGE_REPORT_CARD_BG = `${D}/card_bg.webp`
export const ESPIONAGE_SHIELD_ICON = `${D}/shield.webp`
export const ESPIONAGE_STATUS_BG = `${D}/status.webp`

export const ESPIONAGE_PAGE_HEADER_ICON = `${D}/espionage-icon.webp`
export const ESPIONAGE_RESOURCE_FRAME_BG = `${D}/resource-frame.webp`
export const ESPIONAGE_PAGE_BG = `${D}/espionage_bg.webp`
export const COUNTER_ESPIONAGE_PAGE_BG = `${D}/counter_espionage_bg.webp`

/** Spy splash chooser (`spy-splash-page`). */
export const SPY_SPLASH_BG = `${D}/spy_bg.webp`
export const SPY_SPLASH_ESPIONAGE_CARD = `${D}/espionage.webp`
export const SPY_SPLASH_COUNTER_CARD = `${D}/counter-espionage.webp`

export const ESPIONAGE_REPORT_TYPE_ICONS = {
  detected: ESPIONAGE_MISSION_ICON_SEARCH,
  captured: ESPIONAGE_SHIELD_ICON,
  ransom: ESPIONAGE_MISSION_ICON_STEAL,
} as const

export const ESPIONAGE_ACTION_BUTTON_ICONS = {
  ransom: ESPIONAGE_MISSION_ICON_STEAL,
  behead: ESPIONAGE_MISSION_ICON_KILL,
  prison: ESPIONAGE_SHIELD_ICON,
} as const

/** Espionage page v2 (`land/espionage/espionage/*`) static chrome/cards/icons. */
export const ESPIONAGE_V2_PRELOAD_URLS: readonly string[] = [
  `${D_V2}/background.webp`,
  `${D_V2}/header.webp`,
  `${D_V2}/header_water.webp`,
  `${D_V2}/header_wheat.webp`,
  `${D_V2}/header_bread.webp`,
  `${D_V2}/header_wood.webp`,
  `${D_V2}/header_stone.webp`,
  `${D_V2}/header_iron.webp`,
  `${D_V2}/header_usdt.webp`,
  `${D_V2}/header_ecs.webp`,
  `${D_V2}/ico_espionage_header.webp`,
  `${D_V2}/panel_active_spies.webp`,
  `${D_V2}/panel_available_operations.webp`,
  `${D_V2}/panel_world_map.webp`,
  `${D_V2}/panel_active_missions.webp`,
  `${D_V2}/panel_completed_reports.webp`,
  `${D_V2}/report_card.webp`,
  `${D_V2}/img_knife.webp`,
  `${D_V2}/img_scroll.webp`,
  `${D_V2}/btn_start_mission.webp`,
  `${D_V2}/map.webp`,
  `${D_V2}/available_operation_card.webp`,
  `${D_V2}/ico_aptitude_peek.webp`,
  `${D_V2}/ico_steal_resources.webp`,
  `${D_V2}/ico_decrease_loyalty.webp`,
  `${D_V2}/ico_kill_general.webp`,
  `${D_V2}/mission_aptitude_peek_card.webp`,
  `${D_V2}/mission_steal_resources_card.webp`,
  `${D_V2}/mission_decrease_loyalty_card.webp`,
  `${D_V2}/mission_kill_general_card.webp`,
  `${D_V2}/character_card.webp`,
  `${D_V2}/character_act_frame.webp`,
  `${D_V2}/character_fire_stamp.webp`,
  `${D_V2}/character_water_stamp.webp`,
  `${D_V2}/character_earth_stamp.webp`,
  `${D_V2}/character_lighting_stamp.webp`,
  `${D_V2}/character_magic_stamp.webp`,
  `${D_V2}/character_physics_stamp.webp`,
  `${D_V2}/character_sun_stamp.webp`,
  `${D_V2}/character_dark_stamp.webp`,
]

/** Shared mission-report modal assets (`Redesign/espionage_mission_modal/*`). */
export const ESPIONAGE_MISSION_MODAL_PRELOAD_URLS: readonly string[] = [
  `${REDESIGN_ESPIONAGE_MISSION_MODAL}/background.webp`,
  `${REDESIGN_ESPIONAGE_MISSION_MODAL}/stamp.webp`,
  `${REDESIGN_ESPIONAGE_MISSION_MODAL}/act_frame.webp`,
  `${REDESIGN_ESPIONAGE_MISSION_MODAL}/character_card.webp`,
]

/** Startup preload — unique blob URLs for espionage flows. */
export const ESPIONAGE_PRELOAD_URLS: readonly string[] = [
  ESPIONAGE_CONTAINER_HEAD_BG,
  ESPIONAGE_CONTAINER_BODY_BG,
  ESPIONAGE_CONTAINER_BACKGROUND,
  ESPIONAGE_MISSION_ICON_SEARCH,
  ESPIONAGE_MISSION_ICON_STEAL,
  ESPIONAGE_MISSION_ICON_LOYAL,
  ESPIONAGE_MISSION_ICON_KILL,
  ESPIONAGE_STAR_FILLED,
  ESPIONAGE_STAR_UNFILLED,
  ESPIONAGE_REPORTS_HEADER_BG,
  ESPIONAGE_REPORTS_PANEL_BG,
  ESPIONAGE_REPORT_CARD_BG,
  ESPIONAGE_SHIELD_ICON,
  ESPIONAGE_STATUS_BG,
  ESPIONAGE_PAGE_HEADER_ICON,
  ESPIONAGE_RESOURCE_FRAME_BG,
  ESPIONAGE_PAGE_BG,
  COUNTER_ESPIONAGE_PAGE_BG,
  SPY_SPLASH_BG,
  SPY_SPLASH_ESPIONAGE_CARD,
  SPY_SPLASH_COUNTER_CARD,
  ESPIONAGE_CASTLE_INFO_BACKGROUND,
  ESPIONAGE_TARGET_CHARACTER_MODAL_BACKGROUND,
  ESPIONAGE_TARGET_CHARACTER_MODAL_CHARACTER_CARD,
  ESPIONAGE_TARGET_CHARACTER_MODAL_BTN_CLOSE,
  ESPIONAGE_TARGET_CHARACTER_MODAL_BTN_START,
  ...ESPIONAGE_MISSION_MODAL_PRELOAD_URLS,
  ...ESPIONAGE_V2_PRELOAD_URLS,
]
